import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-5">
          <div>
            <Link to="/" className="font-heading text-xl font-bold text-primary-500">
              韩漫画网
            </Link>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              精选好看的韩国漫画，提供韩漫在线免费阅读服务。高清韩漫大全，画质清晰，视觉享受。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">
              <a href="#footer-categories" className="hover:text-primary-500 transition-colors">漫画分类</a>
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">
              <a href="#footer-more" className="hover:text-primary-500 transition-colors">更多分类</a>
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">
              <a href="#footer-about" className="hover:text-primary-500 transition-colors">关于</a>
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#contact" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                  联系我们
                </a>
              </li>
              <li>
                <a href="#privacy" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                  隐私政策
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2026 韩漫画网. 好看的韩国漫画在线免费阅读平台.
          </p>
          <p className="text-xs text-foreground-500">
            好看的韩国漫画 · 韩漫在线免费阅读 · 高清韩漫大全
          </p>
        </div>
      </div>
    </footer>
  );
}